angular.module('app').directive('format', ['$filter', function ($filter) {
    return {
        require: '?ngModel',
        link: function (scope, elem, attrs, ctrl) {
            if (!ctrl) return;

            ctrl.$formatters.unshift(function (a) {
                return $filter(attrs.format)(ctrl.$modelValue)
            });

            ctrl.$parsers.unshift(function (viewValue) {
                switch (attrs.format) {
                    case 'moeda':
                        elem.priceFormat({
                            prefix: 'R$ ',
                            centsSeparator: ',',
                            thousandsSeparator: '.',
                            centsLimit: attrs.precision ? Number(attrs.precision) : 2,
                        });
                        break;
                    case 'number':
                    case 'decimal':
                        elem.priceFormat({
                            prefix: '',
                            centsSeparator: ',',
                            thousandsSeparator: '.',
                            centsLimit: attrs.precision ? Number(attrs.precision) : 2,
                        });
                        break;
                    case 'integer':
                        elem.priceFormat({
                            prefix: '',
                            centsSeparator: '',
                            thousandsSeparator: '',
                            centsLimit: 0
                        });
                        break;
                    case 'percentual':
                        elem.priceFormat({
                            prefix: '',
                            centsSeparator: ',',
                            thousandsSeparator: '.',
                            clearPrefix: true,
                            centsLimit: attrs.precision ? Number(attrs.precision) : 2,
                        });
                        break;
                }

                return elem[0].value;
            });
        }
    };
}]);

angular.module('app').directive('convertToNumber', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (val) {
                return parseInt(val, 10);
            });
            ngModel.$formatters.push(function (val) {
                if (typeof val == 'undefined' || val === null) return null;
                return '' + val;
            });
        }
    };
});


angular.module('datetimepicker', []).directive('datetimepicker', function ($rootScope) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
            var config = {
                format: 'DD/MM/YYYY HH:mm',
                locale: moment.locale('pt-br'),
                icons: {
                    time: 'far fa-clock',
                    date: 'fa fa-calendar',
                    up: 'fa fa-arrow-up',
                    down: 'fa fa-arrow-down',
                    previous: 'fa fa-chevron-left',
                    next: 'fa fa-chevron-right',
                    today: 'fa fa-calendar-check-o',
                    clear: 'fa fa-trash',
                    close: 'fa fa-times'
                },
            };

            var userConfig = angular.fromJson('{' + attrs.datetimepicker + '}');
            config = angular.extend(config, userConfig);

            var idRandom = makeid();


            element.attr('id', idRandom);
            element.addClass('datetimepicker');
            element.attr('data-target-input', 'nearest');
            element.find('input')
                .addClass('datetimepicker-input')
                .attr('maxlength', config.format.length)
                .attr('data-target', '#' + idRandom);

            element.find('.input-group-addon').last().addClass('input-group-append')
                .attr('data-target', '#' + idRandom)
                .attr('data-toggle', 'datetimepicker');

            element.datetimepicker(config);

            if (element.find('input')) input = element.find('input');
            else input = element;

            ctrl.$formatters.push(function (value) {
                return value ? value : '';
            });

            element.find('input').on("keyup change", function (e) {
                /**
                 * No android não é possível identificar a letra digitada
                 */
                const isUnidentified = e.key === "Unidentified";
                const isBackspace = e.key == "Backspace";

                scope.$apply(function () {
                    value = element.find('input').val();
                    value = value.replace(/[^0-9\ \:\/]/g, '');
                    const maskStr = config.format.replace(/[^\ \: \/]/g, '0');
                    const mask = new StringMask(maskStr);
                    let maskedValue = mask.apply(value.replace(/[^0-9]/g, ''));
                    if (!isUnidentified) {
                        if (isBackspace) {
                            const lastChar = maskedValue.substr(-1);
                            if (lastChar.match(/[^0-9]/)) {
                                maskedValue = maskedValue.substr(0, maskedValue.length - 1);
                            }
                        }
                    } else {
                        let lastChar = maskedValue.substr(-1);
                        while (lastChar.match(/[^0-9]/)) {
                            maskedValue = maskedValue.substr(0, maskedValue.length - 1);
                            lastChar = maskedValue.substr(-1);
                        }
                    }
                    ctrl.$setViewValue(maskedValue);
                });
            });

            element.on('change.datetimepicker', function (e, a, b) {
                scope.$apply(function () {
                    if (e.date) {
                        ctrl.$setValidity('datetime', true);
                        ctrl.$setViewValue(e.date.format(config.format));
                    }
                });
            });
        }
    };
});

angular.module('app').directive('uncapitalize', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, modelCtrl) {
            var uncapitalize = function (inputValue) {
                if (inputValue == undefined) inputValue = '';
                var uncapitalized = inputValue.toLowerCase();
                if (uncapitalized !== inputValue) {
                    modelCtrl.$setViewValue(uncapitalized);
                    modelCtrl.$render();
                }
                return uncapitalized;
            }
            modelCtrl.$parsers.push(uncapitalize);
            uncapitalize(scope[attrs.ngModel]); // capitalize initial value
        }
    };
});

angular.module('app').directive('capitalize', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, modelCtrl) {
            var capitalize = function (inputValue) {
                if (inputValue == undefined) inputValue = '';
                var capitalized = inputValue.toUpperCase();
                if (capitalized !== inputValue) {
                    modelCtrl.$setViewValue(capitalized);
                    modelCtrl.$render();
                }
                return capitalized;
            }
            modelCtrl.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]); // capitalize initial value
        }
    };
});


angular.module('app').directive('modalFooterFlutuante', function ($interval, $timeout) {
    return {
        restrict: 'A',
        controller: function ($scope, $http) {
            $scope.ultimaAlturaModal;
            $scope.ultimoScrollModal;

            $scope.mudouAlturaModal = function (element) {
                return $scope.ultimaAlturaModal != $(element).closest('.modal').find('.modal-content').height();
            }

            $scope.mudouScrollModal = function (element) {
                var diff = $scope.ultimoScrollModal - $(element).closest('.modal').scrollTop();
                if (diff < 0) diff *= -1;
                var margem = 2; //Existe um bug no scroll que fica chamando o evento indo e voltando para o scrolltop, esta margem é para contornar o problema
                return diff > margem;
            }

            $scope.doResize = function (element) {
                if ($scope.resizing) return;

                $scope.resizing = true;

                $(element).css('opacity', 0);
                $(element).parent().find('modal-body').css('margin-bottom', '70px');
                var hModal = $(element).closest('.modal').height();
                var hElement = $(element).outerHeight();
                var scrollTop = $(element).closest('.modal').scrollTop();
                var modalBodyOffsettop = $(element).closest('.modal').find('.modal-body')[0].offsetTop;
                var top = hModal + scrollTop - hElement - modalBodyOffsettop + 26;

                if ($(window).width() > 768) {
                    $(element).css('position', 'fixed');
                    $(element).css('top', top);
                    $(element).css('background-color', '#fff');
                    $(element).css('width', '100%');
                }
                else {
                    $(element)[0].style.removeProperty('position');
                    $(element)[0].style.removeProperty('top');
                    $(element)[0].style.removeProperty('background-color');
                    $(element)[0].style.removeProperty('width');
                }

                $scope.ultimoScrollModal = scrollTop;
                $scope.ultimaAlturaModal = $(element).closest('.modal').find('.modal-content').height();
                $(element).css('opacity', 1);
                $scope.resizing = false;
            };
        },
        link: function (scope, element, attrs, ngModel) {
            /* Fazer o footer ficar sempre visível, independente do tamanho do scroll
             **/

            $(element).css('transition', 'opacity 0.5s ease-in');
            $(element).closest('.modal').find('.modal-content').css('padding-bottom', 40);

            $(element).closest('.modal').scroll(function () {
                if (!scope.mudouScrollModal(element)) return;
                $(element).css('opacity', 0);
                $(element).addClass('hide');

                if (scope.timeoutScroll) {
                    $timeout.cancel(scope.timeoutScroll);
                }

                scope.timeoutScroll = $timeout(function () {
                    $(element).removeClass('hide');
                    scope.doResize(element);
                }, 200);
            });

            //Ao mudar de aba, recalcular             
            $(element).closest('.modal').on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
                $(element).closest('.modal').scrollTop(0);
            });

            //Ao iniciar, recalcular
            $(element).closest('.modal').on('shown.bs.modal', function (e) {
                scope.doResize(element);
            });

            $(window).resize(function () {
                scope.doResize(element);
            });

            $(element).closest('.modal').on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
                if (scope.timeoutTabChange) {
                    $timeout.cancel(scope.timeoutTabChange);
                }

                scope.timeoutTabChange = $timeout(function () {
                    scope.doResize(element);
                }, 200);
            });

            $interval(function () {
                if (scope.mudouAlturaModal(element))
                    scope.doResize(element);
            }, 1000);
        }
    };
});

angular.module('app').directive("owlCarousel", ['$timeout', function ($timeout) {
    return {
        restrict: 'E',
        transclude: false,
        controller: function ($scope, $http) {
            $scope.instance;

            $scope.initCarousel = function (element) {

                if ($scope.instance) {
                    $scope.instance.trigger('destroy.owl.carousel');
                    $(element).find('.owl-item').remove();
                }

                // provide any default options you want
                var defaultOptions = {
                };
                var customOptions = $scope.$eval($(element).attr('data-options'));
                // combine the two options objects
                for (var key in customOptions) {
                    defaultOptions[key] = customOptions[key];
                }

                // init carousel
                $timeout(function () {
                    $scope.instance = $(element).owlCarousel(defaultOptions);
                }, 500);
            };

        },
        link: function ($scope, element) {

            $scope.$watchCollection('vitrines', function () {
                $scope.initCarousel(element);
            });

            $(element).on('change.owl.carousel', function (event) {
                const iframe = $(element).find('.owl-item.active iframe')[0];
                if (iframe && iframe.contentWindow) {
                    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                }
            });

            $(element).on('play.owl.video', function () {
                $timeout(function () {
                    console.log('oi');

                    const iframe = $(element).find('.owl-item.active iframe')[0];
                    if (iframe && iframe.contentWindow) {
                        console.log('oi2');
                        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                    }
                }, 3000);

            })


        }
    };
}])